<template>
  <n-dialog-provider>
    <n-spin class="default" size="large" stroke="#00c4fb" :show="spinState">
      <router-view />
    </n-spin>
  </n-dialog-provider>
</template>
<script>
import { provide, ref, readonly} from "vue"
export default {
  setup() {
    let spinState = ref(false) 
    const changeSpinState = ()=>{ 
      spinState.value = !spinState.value
    } 
    provide('spinState',readonly(spinState)) 
    provide('changeSpinState',changeSpinState) 
    return {
      spinState
    }
  }
}
</script>
<style lang="less">
#app{
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  .default {
    width: 100%;
    max-width: 768px;
    overflow: auto;
    padding: 12px;
    background-color: #ECEFF1;
  }
}
</style>